import { Divider } from "@mui/material";
import React from "react";
import {
  Appointment,
  ParticipantData,
} from "../interface/bookingOverviewInterface";
import AppointmentListView from "./appointmentListView";

const RenderAppointment = ({
  appointment,
  index,
  participant,
}: {
  appointment: Appointment;
  index: number;
  participant: ParticipantData;
}) => (
  <React.Fragment>
    <AppointmentListView appointment={appointment} number={index} />
    {index !== participant.appointments.data.length - 1 && <Divider sx={{}} />}
  </React.Fragment>
);

export default RenderAppointment;
